import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetUsersForSalesPersonLookupQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.UserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserDocumentSortInput> | Types.UserDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUsersForSalesPersonLookupQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPortalBuyersForCustomerDeleteQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.UserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserDocumentSortInput> | Types.UserDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPortalBuyersForCustomerDeleteQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type UserNameLookupFragment = { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string };

export type GetMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'UserDocument', profileImageUrl?: string | null, id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null } | null };

export type UserLanguagePreferenceFragment = { __typename?: 'UserDocument', languagePreference: Types.LanguagePreference };

export type GetMyLanguagePreferenceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyLanguagePreferenceQuery = { __typename?: 'Query', me?: { __typename?: 'UserDocument', languagePreference: Types.LanguagePreference } | null };

export type UserIgnoredMissingDataFragment = { __typename?: 'UserDocument', id: string, ignoredMissingData: Array<{ __typename?: 'IgnoredMissingData', code: string, subjectId?: string | null }> };

export type GetMyIgnoredMissingDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyIgnoredMissingDataQuery = { __typename?: 'Query', me?: { __typename?: 'UserDocument', id: string, ignoredMissingData: Array<{ __typename?: 'IgnoredMissingData', code: string, subjectId?: string | null }> } | null };

export type NotificationPreferencesFragment = { __typename?: 'UserDocument', notificationEmailEnabled: boolean, notificationSmsEnabled: boolean, notificationPushEnabled: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, verifiedPhoneNumber?: string | null, pendingPhoneNumber?: string | null, smsCarrierBlockedAt?: Types.TDateISO | null, notificationEmailDeliveryMode: Types.NotificationDeliveryMode, notificationSmsDeliveryMode: Types.NotificationDeliveryMode, notificationKindOverrides: Array<{ __typename?: 'NotificationKindPreferenceData', kind: Types.NotificationKind, inApp: boolean, email: boolean, push: boolean, sms: boolean }> };

export type GetMyNotificationPreferencesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyNotificationPreferencesQuery = { __typename?: 'Query', me?: { __typename?: 'UserDocument', notificationEmailEnabled: boolean, notificationSmsEnabled: boolean, notificationPushEnabled: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, verifiedPhoneNumber?: string | null, pendingPhoneNumber?: string | null, smsCarrierBlockedAt?: Types.TDateISO | null, notificationEmailDeliveryMode: Types.NotificationDeliveryMode, notificationSmsDeliveryMode: Types.NotificationDeliveryMode, notificationKindOverrides: Array<{ __typename?: 'NotificationKindPreferenceData', kind: Types.NotificationKind, inApp: boolean, email: boolean, push: boolean, sms: boolean }> } | null };

export type GetUsersForUserAdminQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.UserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserDocumentSortInput> | Types.UserDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUsersForUserAdminQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type UserAdminFragment = { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, fusionAuthUserId?: string | null, roles: Array<Types.UserRole>, customerId?: string | null, assignedCustomerIds: Array<string>, assignedSiteIds: Array<string>, assignedRoutes: Array<string>, status: Types.UserStatus, lastModified: Types.TDateISO, lastLoginAt?: Types.TDateISO | null };

export type GetUserInvitesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserInvitesQuery = { __typename?: 'Query', userInvites: Array<{ __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, code: string, status: number, emailStatus: number, emailError: string, emailSentAt?: Types.TDateISO | null, expiresInDays: number, expiresAt: Types.TDateISO, createdAt: Types.TDateISO, resentAt?: Types.TDateISO | null }> };

export type UserInviteAdminFragment = { __typename?: 'UserInviteDocument', id: string, inviteId: string, recipientEmail: string, code: string, status: number, emailStatus: number, emailError: string, emailSentAt?: Types.TDateISO | null, expiresInDays: number, expiresAt: Types.TDateISO, createdAt: Types.TDateISO, resentAt?: Types.TDateISO | null };

export const UserNameLookupFragmentDoc = new TypedDocumentString(`
    fragment UserNameLookup on UserDocument {
  id
  userId
  fullName
  email
}
    `, {"fragmentName":"UserNameLookup"});
export const UserLanguagePreferenceFragmentDoc = new TypedDocumentString(`
    fragment UserLanguagePreference on UserDocument {
  languagePreference
}
    `, {"fragmentName":"UserLanguagePreference"});
export const UserIgnoredMissingDataFragmentDoc = new TypedDocumentString(`
    fragment UserIgnoredMissingData on UserDocument {
  id
  ignoredMissingData {
    code
    subjectId
  }
}
    `, {"fragmentName":"UserIgnoredMissingData"});
export const NotificationPreferencesFragmentDoc = new TypedDocumentString(`
    fragment NotificationPreferences on UserDocument {
  notificationEmailEnabled
  notificationSmsEnabled
  notificationPushEnabled
  phoneNumber
  phoneNumberVerified
  verifiedPhoneNumber
  pendingPhoneNumber
  smsCarrierBlockedAt
  notificationEmailDeliveryMode
  notificationSmsDeliveryMode
  notificationKindOverrides {
    kind
    inApp
    email
    push
    sms
  }
}
    `, {"fragmentName":"NotificationPreferences"});
export const UserAdminFragmentDoc = new TypedDocumentString(`
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}
    `, {"fragmentName":"UserAdmin"});
export const UserInviteAdminFragmentDoc = new TypedDocumentString(`
    fragment UserInviteAdmin on UserInviteDocument {
  id
  inviteId
  recipientEmail
  code
  status
  emailStatus
  emailError
  emailSentAt
  expiresInDays
  expiresAt
  createdAt
  resentAt
}
    `, {"fragmentName":"UserInviteAdmin"});
export const GetUsersForSalesPersonLookupDocument = new TypedDocumentString(`
    query GetUsersForSalesPersonLookup($where: UserDocumentFilterInput, $order: [UserDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  users(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...UserNameLookup
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment UserNameLookup on UserDocument {
  id
  userId
  fullName
  email
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPortalBuyersForCustomerDeleteDocument = new TypedDocumentString(`
    query GetPortalBuyersForCustomerDelete($where: UserDocumentFilterInput, $order: [UserDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  users(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...UserNameLookup
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment UserNameLookup on UserDocument {
  id
  userId
  fullName
  email
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMeDocument = new TypedDocumentString(`
    query GetMe {
  me {
    ...UserAdmin
    profileImageUrl
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}`);
export const GetMyLanguagePreferenceDocument = new TypedDocumentString(`
    query GetMyLanguagePreference {
  me {
    ...UserLanguagePreference
  }
}
    fragment UserLanguagePreference on UserDocument {
  languagePreference
}`);
export const GetMyIgnoredMissingDataDocument = new TypedDocumentString(`
    query GetMyIgnoredMissingData {
  me {
    ...UserIgnoredMissingData
  }
}
    fragment UserIgnoredMissingData on UserDocument {
  id
  ignoredMissingData {
    code
    subjectId
  }
}`);
export const GetMyNotificationPreferencesDocument = new TypedDocumentString(`
    query GetMyNotificationPreferences {
  me {
    ...NotificationPreferences
  }
}
    fragment NotificationPreferences on UserDocument {
  notificationEmailEnabled
  notificationSmsEnabled
  notificationPushEnabled
  phoneNumber
  phoneNumberVerified
  verifiedPhoneNumber
  pendingPhoneNumber
  smsCarrierBlockedAt
  notificationEmailDeliveryMode
  notificationSmsDeliveryMode
  notificationKindOverrides {
    kind
    inApp
    email
    push
    sms
  }
}`);
export const GetUsersForUserAdminDocument = new TypedDocumentString(`
    query GetUsersForUserAdmin($where: UserDocumentFilterInput, $order: [UserDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  users(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...UserAdmin
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment UserAdmin on UserDocument {
  id
  userId
  fullName
  email
  fusionAuthUserId
  roles
  customerId
  assignedCustomerIds
  assignedSiteIds
  assignedRoutes
  status
  lastModified
  lastLoginAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetUserInvitesDocument = new TypedDocumentString(`
    query GetUserInvites {
  userInvites(includeExpired: true) {
    ...UserInviteAdmin
  }
}
    fragment UserInviteAdmin on UserInviteDocument {
  id
  inviteId
  recipientEmail
  code
  status
  emailStatus
  emailError
  emailSentAt
  expiresInDays
  expiresAt
  createdAt
  resentAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetUsersForSalesPersonLookup: build.query<GetUsersForSalesPersonLookupQuery, GetUsersForSalesPersonLookupQueryVariables | void>({
      query: (variables) => ({ document: GetUsersForSalesPersonLookupDocument, variables })
    }),
    GetPortalBuyersForCustomerDelete: build.query<GetPortalBuyersForCustomerDeleteQuery, GetPortalBuyersForCustomerDeleteQueryVariables | void>({
      query: (variables) => ({ document: GetPortalBuyersForCustomerDeleteDocument, variables })
    }),
    GetMe: build.query<GetMeQuery, GetMeQueryVariables | void>({
      query: (variables) => ({ document: GetMeDocument, variables })
    }),
    GetMyLanguagePreference: build.query<GetMyLanguagePreferenceQuery, GetMyLanguagePreferenceQueryVariables | void>({
      query: (variables) => ({ document: GetMyLanguagePreferenceDocument, variables })
    }),
    GetMyIgnoredMissingData: build.query<GetMyIgnoredMissingDataQuery, GetMyIgnoredMissingDataQueryVariables | void>({
      query: (variables) => ({ document: GetMyIgnoredMissingDataDocument, variables })
    }),
    GetMyNotificationPreferences: build.query<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables | void>({
      query: (variables) => ({ document: GetMyNotificationPreferencesDocument, variables })
    }),
    GetUsersForUserAdmin: build.query<GetUsersForUserAdminQuery, GetUsersForUserAdminQueryVariables | void>({
      query: (variables) => ({ document: GetUsersForUserAdminDocument, variables })
    }),
    GetUserInvites: build.query<GetUserInvitesQuery, GetUserInvitesQueryVariables | void>({
      query: (variables) => ({ document: GetUserInvitesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetUsersForSalesPersonLookupQuery, useLazyGetUsersForSalesPersonLookupQuery, useGetPortalBuyersForCustomerDeleteQuery, useLazyGetPortalBuyersForCustomerDeleteQuery, useGetMeQuery, useLazyGetMeQuery, useGetMyLanguagePreferenceQuery, useLazyGetMyLanguagePreferenceQuery, useGetMyIgnoredMissingDataQuery, useLazyGetMyIgnoredMissingDataQuery, useGetMyNotificationPreferencesQuery, useLazyGetMyNotificationPreferencesQuery, useGetUsersForUserAdminQuery, useLazyGetUsersForUserAdminQuery, useGetUserInvitesQuery, useLazyGetUserInvitesQuery } = injectedRtkApi;
